import { createReducer } from '../../utils';
import types from './types';

export const initialState = {
    categorySubline: {}
};

const ACTION_HANDLERS = {
    [types.FETCH_CATEGORY_SUBLINE.SUCCESS]: (state, action) => ({
        ...state,
        categorySubline: action.payload
    })
};

export default createReducer(ACTION_HANDLERS, initialState);
